import { useCallback } from 'react';
import PropTypes from 'prop-types';

import useFieldTransmission from '@gef-ui/form-core/hooks/field/useFieldTransmission';
import AutocompleteGEF from '@gef-ui/form-material/Autocomplete';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import TextField from '@gef-ui/form-material/TextField';
import { resolveValidationColor } from '@gef-ui/form-material/utils';

// todo - isRequired props

// Autocomplete with required prop + validation color
export const AutocompleteCustom = ({
	label,
	fieldName,
	required = false,
	validationDisplay = validationDisplayTypes.HIDDEN,
	...rest
}) => {
	const { validationType } = useFieldTransmission({ fieldName });

	const renderInput = useCallback(
		(params) => {
			return (
				<TextField
					{...params}
					label={label}
					fieldName={fieldName}
					fullWidth
					required={required}
					validationDisplay={validationDisplay}
					slotProps={{
						inputLabel: {
							validation: resolveValidationColor(validationType),
						},
						input: {
							...params?.InputProps,
						},
					}}
				/>
			);
		},
		[validationType, fieldName, label, required, validationDisplay],
	);

	return <AutocompleteGEF fieldName={fieldName} label={label} renderInput={renderInput} {...rest} />;
};

AutocompleteCustom.propTypes = {
	fieldName: PropTypes.string,
	label: PropTypes.string,
	required: PropTypes.bool,
	validationDisplay: PropTypes.string,
};

export default AutocompleteCustom;
